import { render, staticRenderFns } from "./NotificationCardForPathActivity.vue?vue&type=template&id=610175aa&scoped=true&"
import script from "./NotificationCardForPathActivity.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForPathActivity.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForPathActivity.vue?vue&type=style&index=0&id=610175aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610175aa",
  null
  
)

export default component.exports